import vuetifyDe from "vuetify/es5/locale/de";
import vuetifyEn from "vuetify/es5/locale/en";
import vuetifyFr from "vuetify/es5/locale/fr";
import vuetifyPl from "vuetify/es5/locale/pl";
import { de } from "./locales/de";
import { en } from "./locales/en";
import { fr } from "./locales/fr";
import { pl } from "./locales/pl";

/**
 * Vuetify asks the app's translator (`src/plugins/vuetify.ts`) for its own texts under `$vuetify.*`
 * ("Sortiere nach", "Keine Daten vorhanden", the table pagination), so each language carries
 * Vuetify's own translations under that key; without them the raw key reached the screen.
 */
export const messages = {
  de: { ...de, $vuetify: vuetifyDe },
  en: { ...en, $vuetify: vuetifyEn },
  fr: { ...fr, $vuetify: vuetifyFr },
  pl: { ...pl, $vuetify: vuetifyPl },
};
